/* Sacha: Norwegian Bokmal fallback for Easy Appointment Booking.
   Only customer-facing text and accessibility labels inside Servicify modals.
   No booking data, values, availability or event handlers are changed. */
(() => {
  'use strict';
  if (!/^(nb|nn|no)(-|$)/i.test(document.documentElement.lang || '')) return;
  const selector = '.servicify-modal-portal';
  const phrases = new Map([
    ['Book with', 'Velg behandler'],
    ['Valgt tidspunkt', 'Ditt bookingsammendrag'],
    ['Any available', 'Første ledige behandler'],
    ['Select a date to view available times.', 'Velg en dato for å se ledige timer.'],
    ['Previous Month', 'Forrige måned'], ['Next Month', 'Neste måned'],
    ['Close', 'Lukk'], ['Time format', 'Tidsformat'],
    ['AM/PM', '12 timer'], ['24h', '24 timer']
  ]);
  const months = [
    ['January', 'Jan', 'januar'], ['February', 'Feb', 'februar'],
    ['March', 'Mar', 'mars'], ['April', 'Apr', 'april'],
    ['May', 'May', 'mai'], ['June', 'Jun', 'juni'],
    ['July', 'Jul', 'juli'], ['August', 'Aug', 'august'],
    ['September', 'Sep', 'september'], ['October', 'Oct', 'oktober'],
    ['November', 'Nov', 'november'], ['December', 'Dec', 'desember']
  ];
  const weekdays = [
    ['Monday', 'Mon', 'Mo', 'mandag', 'ma'],
    ['Tuesday', 'Tue', 'Tu', 'tirsdag', 'ti'],
    ['Wednesday', 'Wed', 'We', 'onsdag', 'on'],
    ['Thursday', 'Thu', 'Th', 'torsdag', 'to'],
    ['Friday', 'Fri', 'Fr', 'fredag', 'fr'],
    ['Saturday', 'Sat', 'Sa', 'lørdag', 'lø'],
    ['Sunday', 'Sun', 'Su', 'søndag', 'sø']
  ];
  const monthLookup = new Map(months.flatMap(([full, short, no]) => [[full, no], [short, no]]));
  const dayLookup = new Map(weekdays.flatMap(([full, short, , no]) => [[full, no], [short, no]]));
  const monthPattern = months.flatMap(([full, short]) => [full, short]).join('|');
  const datePattern = new RegExp('\\b(\\d{1,2})\\s+(' + monthPattern + ')\\.?\\s+(\\d{4})\\b', 'g');
  const usDatePattern = new RegExp('\\b(' + monthPattern + ')\\s+(\\d{1,2}),?\\s+(\\d{4})\\b', 'g');
  function dateText(text) {
    return text
      .replace(datePattern, (_, day, month, year) => day + '. ' + monthLookup.get(month) + ' ' + year)
      .replace(usDatePattern, (_, month, day, year) => day + '. ' + monthLookup.get(month) + ' ' + year)
      .replace(/\b(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|Mon|Tue|Wed|Thu|Fri|Sat|Sun)\b,?\s+(?=\d{1,2}\.)/g,
        (_, day) => dayLookup.get(day) + ' ');
  }
  function translated(text, element) {
    const trimmed = text.trim();
    if (phrases.has(trimmed)) return text.replace(trimmed, phrases.get(trimmed));
    if (element.closest('.DayPicker-Weekday')) {
      const day = weekdays.find(row => row.slice(0, 3).includes(trimmed));
      if (day) return text.replace(trimmed, day[4]);
    }
    if (element.closest('.DayPicker-Caption')) {
      const month = monthLookup.get(trimmed);
      if (month) return text.replace(trimmed, month);
    }
    // Limit date conversion to calendar text, never names or treatment copy.
    if (element.closest('.DayPicker, [data-servicify="calendar-time-picker"], [data-servicify="booking-preview-selected-time"]')) {
      return dateText(text);
    }
    return text;
  }
  function translateRoot(root) {
    root.querySelectorAll('[aria-label], [title], abbr, img[alt]').forEach(element => {
      ['aria-label', 'title', 'alt'].forEach(attribute => {
        const old = element.getAttribute(attribute);
        if (!old) return;
        let value = phrases.get(old) || old;
        if (element.closest('.DayPicker')) {
          const day = weekdays.find(row => row.slice(0, 3).includes(old));
          value = day ? day[3] : dateText(value);
        }
        if (old === 'current timezone') value = 'Gjeldende tidssone';
        if (value !== old) element.setAttribute(attribute, value);
      });
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const changes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const element = node.parentElement;
      if (!element || element.closest('script, style, textarea, input, [contenteditable], [data-servicify="event-title"], [data-servicify="description"], [data-servicify="custom-field-wrapper"]')) continue;
      const value = translated(node.nodeValue, element);
      if (value !== node.nodeValue) changes.push([node, value]);
    }
    // Keep React's nodes intact; changing only their text preserves interactions.
    changes.forEach(([node, value]) => { node.nodeValue = value; });
  }

  function bookingSummary(root) {
    const selected = root.querySelector('[data-servicify="booking-preview-selected-time"]');
    if (!selected) return;
    const text = selected.textContent.replace(/\s+/g, ' ').trim();
    const parts = text.match(/^(.+?) kl\.\s+(.+?)\s+\(([^)]+)\)\s+hos\s+(.+)$/);
    if (!parts) return;
    let product = null;
    try {
      const config = document.getElementById('sacha-booking-product');
      if (config) product = JSON.parse(config.textContent);
    } catch (_) {}
    const eventTitle = document.querySelector('[data-servicify="event-title"]');
    const treatment = product?.title || eventTitle?.textContent.replace(/^Velg et tidspunkt for\s+/, '').trim();
    if (!treatment) return;
    const variantInput = document.querySelector('#MainContent form[action*="/cart/add"] [name="id"]');
    const variant = product?.variants.find(item => String(item.id) === variantInput?.value);
    const variantName = variant?.title && variant.title !== 'Default Title' ? variant.title : 'Standard behandling';
    const rows = [
      ['Behandling', treatment],
      ['Variant', variantName],
      ['Behandler', parts[4]],
      ['Dato', parts[1]],
      ['Klokkeslett', parts[2].replace(/\s*-\s*/g, '–') + ' (norsk tid)'],
      ['Oppmøtested', 'Sacha Aesthetic Clinic, Festningsgata 4E, 4608 Kristiansand'],
      ['Betaling', 'Velg betalingsmåte i kassen: betal på nett eller velg «Betal i klinikken».']
    ];
    const signature = JSON.stringify(rows);
    let panel = root.querySelector('[data-sacha-booking-summary]');
    if (!panel) {
      panel = document.createElement('dl');
      panel.setAttribute('data-sacha-booking-summary', '');
      panel.style.cssText = 'margin:0 0 20px;padding:16px;background:#f4efe7;border:1px solid #ddd5ca;border-radius:8px;display:grid;grid-template-columns:minmax(82px,26%) minmax(0,1fr);gap:10px 12px;font-size:14px;line-height:1.5;color:#37322e;';
      selected.parentElement.before(panel);
    }
    if (panel.getAttribute('data-summary-content') !== signature) {
      const content = document.createDocumentFragment();
      rows.forEach(([label, value]) => {
        const term = document.createElement('dt');
        term.textContent = label;
        term.style.cssText = 'font-weight:600;margin:0;overflow-wrap:anywhere;';
        const description = document.createElement('dd');
        description.textContent = value;
        description.style.cssText = 'margin:0;overflow-wrap:anywhere;';
        content.append(term, description);
      });
      panel.replaceChildren(content);
      panel.setAttribute('data-summary-content', signature);
    }
    selected.parentElement.style.display = 'none';
  }

  const watched = new WeakSet();
  let pending = false;
  function refresh() {
    pending = false;
    document.querySelectorAll(selector).forEach(root => {
      if (!watched.has(root)) {
        watched.add(root);
        new MutationObserver(schedule).observe(root, {
          subtree: true, childList: true, characterData: true,
          attributes: true, attributeFilter: ['aria-label', 'title', 'alt']
        });
      }
      translateRoot(root);
      bookingSummary(root);
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(refresh); }
  }
  function start() {
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      ))) schedule();
    }).observe(document.body, {childList: true, subtree: true});
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
